import { reactive } from 'vue'

const state = reactive({
  open: false,
  title: '',
  message: '',
  confirmText: 'Подтвердить',
  cancelText: 'Отмена',
  tone: 'danger'
})

let resolver = null

function ask(options = {}) {
  if (resolver) resolver(false)
  Object.assign(state, {
    open: true,
    title: options.title || 'Подтвердите действие',
    message: options.message || 'Продолжить?',
    confirmText: options.confirmText || 'Подтвердить',
    cancelText: options.cancelText || 'Отмена',
    tone: options.tone || 'danger'
  })
  return new Promise((resolve) => { resolver = resolve })
}

function finish(result) {
  state.open = false
  const current = resolver
  resolver = null
  current?.(result)
}

export function useConfirm() {
  return { state, ask, confirm: () => finish(true), cancel: () => finish(false) }
}
